import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SysDialogConfimacao,{attrs:{"texto_confirmacao":"Deseja realmente apagar esse produto combinado?","txt_botao":"sim, apagar","largura":400},on:{"confirmacao":_setup.apagarProdutoCombinado},scopedSlots:_vm._u([{key:"ativador",fn:function({callback}){return [_c(VBtn,{attrs:{"icon":""},on:{"click":callback}},[_c(VIcon,[_vm._v("mdi-delete")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }